import { useAppSelector, useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { GlobalResearchAssistant } from '@verantos-dev/feature-research-assistant';
import {
  AppPageLayoutContainer,
  type AppPageLayoutContainerProps,
} from '@verantos-dev/shared-layout';

import { useVepSectionName } from './useVepSectionName';
import { useVepSidebarConfig } from './useVepSidebarConfig';
import { useAllowedApps } from '../hooks/useAllowedApps';

// TODO: cleanup with research_assistant_gen_3 ff
const PROJECT_ROOT_PATTERN = '^/projects/[^/]+/?$';
const PROJECT_TREE_PATTERN = '^/projects/[^/]+(/.*)?$';
/**
 * VEP-specific container for AppPageLayout.
 * Configures chat interface paths, research assistant slot, and sidebar configuration for the VEP app.
 */
export const VepAppPageLayoutContainer = () => {
  const sidebarConfig = useVepSidebarConfig();
  const allowedApps = useAllowedApps();
  const getSectionName = useVepSectionName();
  // const appId = EvidencePlatformSidebarAppID.projects;
  const appId = useAppSelector((state) => state.app.id);

  // TODO: cleanup with research_assistant_gen_3 ff
  // gen_3 ON: chat-interface layout (full-height, no footer) covers the
  // whole agent-first project tree (root + every nested artifact route).
  // gen_3 OFF: only the project landing page gets that layout — legacy
  // cohort/data-reliability pages keep their pre-existing layout.
  const isAgentFirstEnabled = useFeatureFlagSplit('research_assistant_gen_3', false);
  const projectChatInterfacePattern = isAgentFirstEnabled
    ? PROJECT_TREE_PATTERN
    : PROJECT_ROOT_PATTERN;

  return (
    <AppPageLayoutContainer
      researchAssistantSlot={<GlobalResearchAssistant />}
      chatInterfacePaths={[
        '/gateway-demo',
        '/research-assistant',
        '/research-assistant-test',
        '/code-list-mapper',
      ]}
      chatInterfacePathPatterns={[projectChatInterfacePattern]}
      disableSidePaddingPaths={['cohortbuilder']}
      sidebarConfig={sidebarConfig}
      allowedApps={allowedApps as unknown as AppPageLayoutContainerProps['allowedApps']}
      platformNameMessageId="appHeader.platform.name"
      // TODO: cleanup with research_assistant_gen_3 ff
      // gen_3 (agent-first) drops the page-name subtitle from the top app bar so
      // "Evidence Platform" is the only product label. Returning '' makes
      // AppHeader hide the "/ <section>" separator + section-name block.
      getSectionName={(appId) =>
        isAgentFirstEnabled ? '' : getSectionName(appId as EvidencePlatformSidebarAppID)
      }
      appId={appId}
      // TODO: cleanup with research_assistant_gen_3 ff
      // gen_3 (agent-first) removes the sidebar section-title headers
      // ("Cohort Management", "System Administration"); nav items + dividers stay.
      hideSectionTitles={Boolean(isAgentFirstEnabled)}
    />
  );
};
